import type { FunctionComponent } from 'react';
import { Link } from 'react-router';

import { useTranslate } from '~/shared/context/use-translate';
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from '~/ui/core/dropdown-menu/DropdownMenu';
import { IconArrowRightUpCircle, IconHorizontalDots } from '~/ui/core/icons';

import { sidebar } from '../../company-settings/constants';
import { buildOrganizationSettingsUrl } from '../../company-settings/route-config';
import { useJobArchitecturePermissions } from '../context/JobArchitecturePermissionsContext';

const warningSignalsSettingsUrl = buildOrganizationSettingsUrl(sidebar.organization.skills);

export const SkillsSectionOptions: FunctionComponent = () => {
    const translate = useTranslate();
    const { canModify } = useJobArchitecturePermissions();

    if (!canModify) {
        return null;
    }

    return (
        <DropdownMenu>
            <DropdownMenuTrigger>
                <button
                    aria-label={translate('common.more')}
                    className="inline-flex items-center justify-center p-xs text-gray-600 hover:text-gray-900 outline-none bg-transparent border-none cursor-pointer"
                    type="button"
                >
                    <IconHorizontalDots size={12} />
                </button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="w-[13.75rem]" side="top">
                <DropdownMenuItem asChild={true} className="justify-between">
                    <Link
                        className="no-underline hover:no-underline"
                        rel="noreferrer"
                        target="_blank"
                        to={warningSignalsSettingsUrl}
                    >
                        <span>{translate('pages.company-settings.skills.warning-signals.title')}</span>
                        <IconArrowRightUpCircle size={14} />
                    </Link>
                </DropdownMenuItem>
            </DropdownMenuContent>
        </DropdownMenu>
    );
};
